module.exports = __webpack_public_path__ + "img/61.1.6290ba62.jpg";